<script>
import '../directives';

export default {
    name: 'TagSelect',
    props: {
        tags: Array,
        placeholder: String,
    },
    data: () => {
        return {
            selectedTags: [],
            isOpen: false,
        }
    },
    methods: {
        onTagSelect(tag) {
            this.selectedTags.push(tag);
            this.deSelectedTags = this.selectedTags.filter(item => item.id !== tag.id);
            this.toggleSelect(false);
            this.$emit('tagsChanged', this.selectedTags);
        },
        onTagDeSelect(tag) {
            this.deSelectedTags.push(tag);
            this.selectedTags = this.selectedTags.filter(item => item.id !== tag.id);
            this.$emit('tagsChanged', this.selectedTags);
        },
        toggleSelect(value) {
            if (typeof value === 'undefined') 
                this.isOpen = !this.isOpen;
            else
                this.isOpen = value;
        },
    },
    computed: {
        notSelectedTags() {
            return this.tags.filter(tag => this.selectedTags.indexOf(tag) === -1);
        }
    }
};
</script>

<template>
    <div class="tag-select">
        <div class="tag-select__value" ref="value" v-on:click="toggleSelect()" v-on:keyup.esc="toggleSelect(false)">
            <span class="tag-select__placeholder" v-if="selectedTags.length === 0">{{ placeholder }}</span>
            <ul class="tag-select__selected" v-if="selectedTags.length > 0">
                <li class="tag-select__selected__tag" v-for="(tag, i) in selectedTags" v-bind:key="i">
                    <span class="tag-select__selected__tag__label" v-html="tag.name"></span>
                    <button class="tag-select__selected__tag__remove" v-on:click="onTagDeSelect(tag)"></button>
                </li>
            </ul>
            <button class="tag-select__toggle" v-bind:class="{'tag-select__toggle--open': isOpen}"></button>
        </div>

        <ul class="tag-select__list" v-if="isOpen" v-closable="{ exclude: ['value'], handler: 'toggleSelect' }">
            <li class="tag-select__list__tag" v-for="(tag, i) in notSelectedTags" v-bind:key="i" v-on:click="onTagSelect(tag)" v-html="tag.name"></li>
        </ul>
        
    </div>
</template>

<style lang="scss" scoped>
.tag-select {
    position: relative;
    width: 100%;
    min-height: 4.2rem;
    padding: 0 3.36rem 0 0.7rem;
    box-sizing: border-box;
    border-top: 0.1rem solid rgba($color-primary-alt, .7);
    border-bottom: 0.1rem solid rgba($color-primary-alt, .7);
    background: lighten($color-primary-alt, 65%);
}

.tag-select__placeholder {
    margin: 0 0.64rem;
    line-height: 2.65;
}
.tag-select__toggle {
    position: absolute;
    top: 50%; right: 0;
    width: 3.36rem; height: 3.36rem;
    margin: -1.68rem 0;
    border: none;
    outline: none;
    background: center url(~@/assets/images/ico-chevron-bottom.svg) no-repeat;
    cursor: pointer;
}
.tag-select__toggle--open {
    transform: rotate(180deg);
}
.tag-select__selected {
    display: block;
    margin: 0;
    padding: 0.4rem 2.88rem 0.4rem 0;
}
.tag-select__list {
    position: absolute;
    top: 100%; left: 0;
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0.8rem;
    border-bottom: 0.1rem solid rgba($color-primary-alt, .7);
    background: lighten($color-primary-alt, 65%);
    z-index: 10;
}
.tag-select__list__tag,
.tag-select__selected__tag {
    display: inline-block;
    width: auto;
    height: 3rem;
    margin: 0.24rem 0.4992rem;
    padding: 0 0.6rem;
    color: $color-primary;
    letter-spacing: 0.046rem;
    white-space: nowrap;
    line-height: 1.9;
    background: rgba($color-primary, .3);
    border-radius: 0.24rem;
    cursor: pointer;
}
.tag-select__selected__tag {
    color: $color-light;
    background: $color-primary-alt;
}
.tag-select__selected__tag__label {
    display: inline-block;
    margin: 0;
}
.tag-select__selected__tag__remove {
    display: inline-block;
    width: 1.6rem; height: 1.6rem;
    margin-left: 0.32rem;
    vertical-align: middle;
    border: none;
    outline: none;
    background: center url(~@/assets/images/ico-remove-tag.svg) no-repeat;
    cursor: pointer;
}
</style>
